export default {"src":"/_next/static/media/napkins.a4e9c27e.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};